import React, { useState} from "react";
import { TMSSearchTextUm} from "./tms-filters-search-um";

export const TMSFiltersUm = ({ isBlankActiveUm, onSearch }) => {
  const [inputValue, setInputValue] = useState(isBlankActiveUm);
    return (
        <TMSSearchTextUm isBlankActiveUm={isBlankActiveUm} onSearch={onSearch}/> 
  );
};
